module.exports = __webpack_public_path__ + "static/img/gift10.261ad28.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/shuang12/gift10.png
// module id = v8mz
// module chunks = 86